import { defineFcm } from '../shared/factory';

export const FCM_PDF_EXPORT_ENABLED = defineFcm('pdf_export_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: ['corgi-front-end', 'export-service'],
		context: 'Signature/comment PDF export',
		description: 'Enables the PDF export option for petition signatures/comments, in addition to CSV',
	});
